import { ColoursObj } from "@eventr/common-storybook";
import { Box, Stack } from "@mui/material";
import type { ReactNode } from "react";
import { useGuestStore } from "feat/guest/guest.store";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { routes } from "routing";
import { useShowExpensesButton } from "./CarouselOverlay";
import ActivityFeedButton from "./slide/newComps/ActivityFeedButton";
import HitBoxIcon from "./slide/newComps/HitBoxIcon";
import CarouselZoneToggle from "./slide/newComps/CarouselZoneToggle";
import CarouselSeeAllItineraries from "./slide/newComps/seeAllItineraries";

/** One control's place on the rail: the same height for each, centred. */
const Slot = ({ children }: { children: ReactNode }) => (
  <Box sx={{ height: "44px", display: "grid", placeItems: "center" }}>{children}</Box>
);

/** The itinerary header's itinerary menu, expenses, alerts and time mode on the tab rail, top to bottom. */
export function RailHeaderControls() {
  const isGuest = useGuestStore((s) => s.isGuestMode);
  const colour = ColoursObj.navbar.icons;
  const showExpenses = useShowExpensesButton();
  const { pushPath } = useGlobalRouter();

  return (
    <Stack sx={{ alignItems: "center", gap: "8px", paddingBottom: "12px" }}>
      {!isGuest && (
        <Slot>
          <CarouselSeeAllItineraries colour={colour} />
        </Slot>
      )}
      {showExpenses && (
        <Slot>
          <HitBoxIcon
            id="rail-expenses"
            icon="Billing"
            colour={colour}
            onClick={() => pushPath(routes.edit.expenses.path)}
          />
        </Slot>
      )}
      {!isGuest && (
        <Slot>
          <ActivityFeedButton colour={colour} align="center" />
        </Slot>
      )}
      <Slot>
        <CarouselZoneToggle colour={colour} />
      </Slot>
      <Box sx={{ width: "40px", borderTop: `1px solid ${ColoursObj.navbar.icons}`, opacity: 0.3 }} />
    </Stack>
  );
}
